import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from 'i18n/CurrentLocale';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { useClipboard } from 'use-clipboard-copy';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as companyActions from 'features/company/companyActions';
import img_InviteYourDrivers from 'img/invite-your-drivers.png';
import rawstrings from 'string-translations/rawstrings';
import { DeviceMode, ReduxState } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { InfoBoxSmall } from 'components/InfoBoxSmall';


// todo: https://concar.atlassian.net/browse/PD-3898
// replace the URL (nl-be) in PhraseApp when Olivier finished the Flemish manual


export function generateInvitationLinkBasedOnParkingMode(defaultParkingMode: DeviceMode) {
    const mode = defaultParkingMode === 'AUTONOMOUS' ? 'SEMI_AUTOMATIC' : defaultParkingMode;
    const modeURLParam = mode.replace(/_/g, '-').toLowerCase();
    return formatMessage(rawstrings.onlineManualLink) + `?mode=${modeURLParam}`;
}

export const InviteYourDriversModal = (props: Props) => {

    useEffect(() => {
        props.getCompanyDetails();
    }, []);

    const clipboard = useClipboard({ copiedTimeout: 1000 });

    const defaultParkingMode: DeviceMode = props?.companyDetails?.companyDetails?.defaultMode ?? 'SEMI_AUTOMATIC';

    return (
        <div id="invite-your-drivers-modal" className="white-modal panel radius-rectangle full-width-form">
            <img src={img_InviteYourDrivers} alt="automatic parking" />
            <h2 className="bold-title">
                <FormattedMessage id="INVITE_YOUR_DRIVERS_TITLE" />
            </h2>
            <p className="text-light">
                <FormattedMessage id="INVITE_YOUR_DRIVERS_TEXT" />
            </p>

            {defaultParkingMode === 'AUTONOMOUS' &&
                <div style={{ marginBottom: 10, textAlign: 'left' }}>
                    <InfoBoxSmall messageId='INVITE_YOUR_DRIVERS_INFO_AUTONOMOUS_MODE' />
                </div>
            }

            <input
                type="text"
                ref={clipboard.target}
                value={generateInvitationLinkBasedOnParkingMode(defaultParkingMode)}
                readOnly
                className="text-field"
                name="inviteYourDriversLink"
            />
            <button className="btn-blue" onClick={clipboard.copy}>
                {clipboard.copied
                    ? <FormattedMessage id="COPY_LINK_SUCCESS" />
                    : <><FontAwesomeIcon icon={faCopy} />&nbsp;<FormattedMessage id="COPY_LINK" /></>
                }
            </button>
        </div>
    );
};


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

function mapStateToProps(state: ReduxState) {
    return {
        companyDetails: state.companyDetails
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        getCompanyDetails: companyActions.getCompanyDetails,
        updateModal: modalWindowActions.updateModalWindow,
        closeModal: modalWindowActions.closeModal
    }, dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteYourDriversModal);